
export interface StateDefinition {
  code: string;
  name: string;
}

export const US_STATES: StateDefinition[] = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }
];

export const STATE_STANDARDS: Record<string, string> = {
  AL: "Alabama Course of Study",
  AK: "Alaska Content Standards",
  AZ: "Arizona's Academic Standards",
  AR: "Arkansas Academic Standards",
  CA: "California Common Core State Standards",
  CO: "Colorado Academic Standards",
  CT: "Connecticut Core Standards",
  DE: "Delaware Common Core State Standards",
  FL: "Benchmarks for Excellent Student Thinking (B.E.S.T.)",
  GA: "Georgia Standards of Excellence (GSE)",
  HI: "Hawaii Common Core Standards",
  ID: "Idaho Content Standards",
  IL: "Illinois Learning Standards",
  IN: "Indiana Academic Standards",
  IA: "Iowa Core",
  KS: "Kansas College and Career Ready Standards",
  KY: "Kentucky Academic Standards",
  LA: "Louisiana Student Standards",
  ME: "Maine Learning Results",
  MD: "Maryland College and Career Ready Standards",
  MA: "Massachusetts Curriculum Frameworks",
  MI: "Michigan Academic Standards",
  MN: "Minnesota Academic Standards",
  MS: "Mississippi College- and Career-Readiness Standards",
  MO: "Missouri Learning Standards",
  MT: "Montana Common Core Standards",
  NE: "Nebraska's College and Career Ready Standards",
  NV: "Nevada Academic Content Standards",
  NH: "New Hampshire College and Career Ready Standards",
  NJ: "New Jersey Student Learning Standards (NJSLS)",
  NM: "New Mexico Common Core State Standards",
  NY: "New York State Next Generation Learning Standards",
  NC: "North Carolina Standard Course of Study",
  ND: "North Dakota Content Standards",
  OH: "Ohio's Learning Standards",
  OK: "Oklahoma Academic Standards",
  OR: "Oregon Academic Standards",
  PA: "Pennsylvania Core Standards",
  RI: "Rhode Island Core Standards",
  SC: "South Carolina College- and Career-Ready Standards",
  SD: "South Dakota Content Standards",
  TN: "Tennessee Academic Standards",
  TX: "Texas Essential Knowledge and Skills (TEKS)",
  UT: "Utah Core Standards",
  VT: "Vermont Framework of Standards and Learning Opportunities",
  VA: "Virginia Standards of Learning (SOL)",
  WA: "Washington K–12 Learning Standards",
  WV: "West Virginia College- and Career-Readiness Standards",
  WI: "Wisconsin Academic Standards",
  WY: "Wyoming Content and Performance Standards"
};

export const getStandardForState = (stateCode: string): string => {
  return STATE_STANDARDS[stateCode] || "Common Core State Standards";
};
